import { getActiveBoard } from '../../board-context.js';

export type LcdI2cUi =
  | {
      mode: 'fixed';
      /** Student-facing label, e.g. "SCL-A5 | SDA-A4". */
      label: string;
      scl: string;
      sda: string;
    }
  | {
      mode: 'selectable';
    };

/** Parallel LCD wiring is not available on Skyrover. */
export function boardSupportsLcdParallel(boardId = getActiveBoard()?.id ?? ''): boolean {
  return boardId.toLowerCase() !== 'skyrover-esp32-s3';
}

/**
 * Board-aware I2C pin UI for the Configure LCD block.
 * Fixed boards show labels only; ESP32 lets students pick SCL/SDA.
 */
export function getLcdI2cUi(boardId = getActiveBoard()?.id ?? ''): LcdI2cUi {
  const id = boardId.toLowerCase();

  if (id === 'arduino-uno' || id === 'arduino-nano') {
    return { mode: 'fixed', label: 'SCL-A5 | SDA-A4', scl: 'A5', sda: 'A4' };
  }

  if (id === 'arduino-mega-2560') {
    return { mode: 'fixed', label: 'SCL-21 | SDA-20', scl: '21', sda: '20' };
  }

  if (id === 'skyrover-esp32-s3') {
    return { mode: 'fixed', label: 'SCL-GPIO41 | SDA-GPIO42', scl: '41', sda: '42' };
  }

  // ESP32 (and other ESP boards): student picks I2C pins.
  if (id.includes('esp32') || id.includes('esp8266')) {
    return { mode: 'selectable' };
  }

  // Safe default for unknown Arduino-like boards.
  return { mode: 'fixed', label: 'SCL-A5 | SDA-A4', scl: 'A5', sda: 'A4' };
}
